<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card>
        <div>
          <div class="w-full">
            <div
              slot="no-body"
              class="tabs-container inventory_tabSec"
              id="view-customer-tab"
            >
              <div class="mr-2 mb-1 order-1">
                <vs-table
                  :max-items="descriptionItems[0]"
                  pagination
                  :data="listToApprove"
                  description
                  search
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="header">
                    <div class="list-heading">
                      {{ $t("sidebar.label.makerCheckerAction") }}
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("admin.label.ActionName") }}</vs-th>
                    <vs-th>{{ $t("admin.label.EntityName") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Maker") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Checker") }}</vs-th>
                    <vs-th>{{ $t("admin.label.ResourceId") }}</vs-th>
                    <vs-th>{{ $t("admin.label.MakerDate") }}</vs-th>
                    <vs-th>{{ $t("admin.label.CheckerDate") }}</vs-th>
                    <vs-th>{{ $t("admin.label.CheckerComment") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Status") }}</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="index"
                      :data="approval"
                      v-for="(approval, index) in data"
                    >
                      <vs-td :data="approval.actionName">{{ approval.actionName }}</vs-td>
                      <vs-td :data="approval.entityName">{{ approval.entityName }}</vs-td>
                      <vs-td :data="approval.maker">{{ approval.maker }}</vs-td>
                      <vs-td :data="approval.checker">{{ approval.checker }}</vs-td>
                      <vs-td :data="approval.resourceId">{{ approval.resourceId }}</vs-td>
                      <vs-td :data="approval.makersDate">{{
                        getDate(approval.madeOnDate)
                      }}</vs-td>
                      <vs-td :data="approval.checkersDate">{{
                        getDate(approval.checkedOnDate)
                      }}</vs-td>
                      <vs-td :data="approval.checkerComment">{{
                        approval.checkerComment
                      }}</vs-td>
                      <vs-td :data="approval.status">
                        <vs-chip
                          :color="getOrderStatusColor(approval.processingResult)"
                          class="product-order-status"
                          >{{ approval.processingResult }}
                        </vs-chip>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('admin.label.Approve')"
        :active.sync="approvePopup"
        class="popup-close mid-popup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6 center">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">{{$t('stockTransfer.label.Are you sure?')}}</div>
            </div>
          </div>
          <div class="vx-row text-center">
            <div class="vx-col sm:w-full w-full" style="padding-right: 8%">
              <vs-button class="mr-2" type="border" @click="approvePopup = false">
                {{ $t("admin.label.Cancel") }}
              </vs-button>

              <vs-button @click="approvalRequest('approve')" color="warning">
                {{ $t("admin.label.Ok") }}
              </vs-button>
            </div>
          </div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('admin.label.Reject')"
        :active.sync="rejectPopup"
        class="popup-close mid-popup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6 center">
            <div class="vx-col sm:w-full w-full">
              <vs-input
                :label="$t('admin.label.Comment')"
                type="text"
                class="w-full font-semibold mb-2 starlabel"
                v-model="rejectComment"
              />
            </div>
          </div>
          <div class="vx-row text-center">
            <div class="vx-col sm:w-full w-full" style="padding-right: 8%">
              <vs-button class="mr-2" type="border" @click="rejectPopup = false">
                {{ $t("admin.label.Cancel") }}
              </vs-button>

              <vs-button @click="approvalRequest('reject')" color="warning">
                {{ $t("admin.label.Ok") }}
              </vs-button>
            </div>
          </div>
        </form>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
      approvePopup: false,
      rejectPopup: false,
      approvalId: null,
      rejectComment: "",
    };
  },

  components: {
    AtomSpinner,
  },
  computed: {
    ...mapState({
      listToApprove: (state) => state.planPrice.makerChecker,
    }),
  },
  methods: {
    getDate(d) {
      if (!d) return "";
      const date = new Date(d);
      const day = String(date.getDate()).padStart(2, "0");
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    },
    async getListToApprove() {
      this.loading = true;
      try {
        const user = JSON.parse(sessionStorage.getItem("ngb:user") || "{}");
        await this.$store.dispatch("planPrice/makerCheckActionData", user.userId);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    getOrderStatusColor(status) {
      if (status === "Invalid") return "dark";
      if (status === "Processed") return "success";
      if (status === "Awaiting Approval") return "warning";
      if (status === "Rejected") return "danger";
      return "success";
    },
  },
  mounted() {
    this.getListToApprove();
  },
};
</script>
<style scoped>
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-warning {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.product-order-status.vs-chip-dark {
  background: #eee !important;
  border: 1px solid #201f1f;
  color: #8a8383 !important;
}
.product-order-status.vs-chip-danger {
  background: #e9d2d2 !important;
  border: 1px solid #f00a0a;
  color: #dd0909 !important;
}
</style>
